(function () {
  'use strict';

  var runtimeState = window.__pawmoryWizardRuntime = window.__pawmoryWizardRuntime || {
    loadCount: 0,
    initCallCount: 0,
    initWizardCallCount: 0,
    initializedSections: 0,
    lastInitReason: ''
  };
  runtimeState.loadCount += 1;

  function escapeHtml(value) {
    var node = document.createElement('div');
    node.textContent = value || '';
    return node.innerHTML;
  }

  function formatMoney(amount) {
    return '$' + (Number(amount || 0) / 100).toFixed(2);
  }

  function formatAddonLabel(amount) {
    return '+$' + (Number(amount || 0) / 100).toFixed(2);
  }

  function readTranslation(source, key, fallback) {
    if (!source || !key) return fallback;
    var value = key.split('.').reduce(function (accumulator, part) {
      return accumulator && typeof accumulator === 'object' ? accumulator[part] : undefined;
    }, source);
    return value == null || value === '' ? fallback : value;
  }

  function getUploadRemoteUrl(entry) {
    if (!entry) return '';
    return typeof entry === 'string' ? entry : String(entry.url || '');
  }

  function getUploadPreviewUrl(entry) {
    if (!entry) return '';
    if (typeof entry === 'string') return entry;
    return String(entry.preview || entry.url || '');
  }

  function getUploadStatus(entry) {
    if (!entry || typeof entry === 'string') return 'uploaded';
    return entry.status || (entry.url ? 'uploaded' : 'pending');
  }

  function buildPriceMarkup() {
    return '<div class="pw-price-row"><div class="pw-price pw-live-price"></div><div class="pw-price pw-price--compare pw-live-price-compare" style="display:none"></div></div>';
  }

  function normalizeMeasurementId(value) {
    return typeof value === 'string' ? value.replace(/\s+/g, '').trim() : '';
  }

  function createWizardSessionId(config) {
    var product = config && config.product ? config.product : {};
    var productKey = String(product.id || product.variantId || 'default').replace(/[^a-zA-Z0-9_-]/g, '');
    var storageKey = 'pawmory_wizard_session_id_' + productKey;
    var storage = null;
    try {
      storage = window.sessionStorage;
    } catch (error) {}

    if (storage) {
      try {
        var existing = storage.getItem(storageKey);
        if (existing) return existing;
      } catch (error) {}
    }

    var randomPart = Math.random().toString(36).slice(2, 10);
    var value = 'wiz_' + Date.now().toString(36) + '_' + randomPart;
    if (storage) {
      try {
        storage.setItem(storageKey, value);
      } catch (error) {}
    }
    return value;
  }

  function createWizardAnalytics(config) {
    var tracking = config && config.tracking ? config.tracking : {};
    var measurementId = normalizeMeasurementId(tracking.measurementId);
    if (measurementId === 'G-2R3SV3MFLR') {
      measurementId = 'G-470SR25M7H';
    }
    var globalState = window.__pawmoryWizardGa4 = window.__pawmoryWizardGa4 || {
      jsInitialized: false,
      configuredIds: {}
    };

    function noop() {}

    if (!measurementId) {
      return {
        enabled: false,
        track: noop
      };
    }

    function ensureGtag() {
      window.dataLayer = window.dataLayer || [];
      if (typeof window.gtag !== 'function') {
        window.gtag = function () {
          window.dataLayer.push(arguments);
        };
      }

      var measurementScriptSrc = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(measurementId);
      var hasMeasurementScript = Array.prototype.some.call(document.scripts, function (node) {
        return node && node.src === measurementScriptSrc;
      });

      if (!hasMeasurementScript) {
        var script = document.createElement('script');
        script.async = true;
        script.src = measurementScriptSrc;
        script.setAttribute('data-pawmory-wizard-ga4', 'true');
        document.head.appendChild(script);
      }

      if (!globalState.jsInitialized) {
        window.gtag('js', new Date());
        globalState.jsInitialized = true;
      }

      if (!globalState.configuredIds[measurementId]) {
        window.gtag('config', measurementId, { send_page_view: false });
        globalState.configuredIds[measurementId] = true;
      }
    }

    return {
      enabled: true,
      measurementId: measurementId,
      track: function (eventName, params) {
        var payload = { send_to: measurementId };
        ensureGtag();
        Object.keys(params || {}).forEach(function (key) {
          if (params[key] == null || params[key] === '') return;
          payload[key] = params[key];
        });
        window.gtag('event', eventName, payload);
      }
    };
  }

  function initGallery(section) {
      var mainImage = section.querySelector('[data-pwt-main-image], .pwt-gallery-main__image');
      var track = section.querySelector('[data-gallery-track]');
      var prevButton = section.querySelector('[data-gallery-arrow="prev"]');
      var nextButton = section.querySelector('[data-gallery-arrow="next"]');
      if (!mainImage || !track) return;

      function updateGalleryControls() {
        var rail = track.parentElement;
        var hasOverflow = track.scrollWidth - track.clientWidth > 4;
        [prevButton, nextButton].forEach(function (button) {
          if (!button) return;
          button.hidden = !hasOverflow;
        });
        if (!hasOverflow) {
          if (rail) {
            rail.setAttribute('data-prev-hidden', 'true');
            rail.setAttribute('data-next-hidden', 'true');
          }
          return;
        }
        if (prevButton) prevButton.disabled = track.scrollLeft <= 2;
        if (nextButton) nextButton.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        if (rail) {
          rail.setAttribute('data-prev-hidden', prevButton ? String(!!prevButton.hidden) : 'true');
          rail.setAttribute('data-next-hidden', nextButton ? String(!!nextButton.hidden) : 'true');
        }
      }

    track.querySelectorAll('.pwt-gallery-thumb').forEach(function (button) {
      button.addEventListener('click', function () {
        var nextImage = button.getAttribute('data-image');
        if (nextImage) {
          mainImage.src = nextImage;
          if ('srcset' in mainImage) {
            mainImage.srcset = nextImage;
          }
        }
        track.querySelectorAll('.pwt-gallery-thumb').forEach(function (thumb) {
          thumb.classList.toggle('is-active', thumb === button);
        });
        button.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      });
    });

      section.querySelectorAll('[data-gallery-arrow]').forEach(function (button) {
        button.addEventListener('click', function () {
          var delta = button.getAttribute('data-gallery-arrow') === 'next' ? 220 : -220;
          track.scrollBy({ left: delta, behavior: 'smooth' });
        });
      });
      track.addEventListener('scroll', updateGalleryControls, { passive: true });
      window.addEventListener('resize', updateGalleryControls);
      updateGalleryControls();
    }

  function initWizard(section) {
    var configNode = section.querySelector('[data-wizard-config]');
    var mount = section.querySelector('[data-wizard-mount]');
    runtimeState.initWizardCallCount += 1;
    if (!configNode) {
      runtimeState.lastInitReason = 'missing_config';
      return;
    }
    if (!mount) {
      runtimeState.lastInitReason = 'missing_mount';
      return;
    }
    if (!window.PawmoryProductWizard) {
      runtimeState.lastInitReason = 'missing_global';
      return;
    }
    if (section.__wizardInitialized) {
      runtimeState.lastInitReason = 'already_initialized';
      return;
    }
    section.__wizardInitialized = true;
    runtimeState.initializedSections += 1;
    runtimeState.lastInitReason = 'initialized';

    var config = JSON.parse(configNode.textContent);
    var translations = config.translations || {};
    var analytics = createWizardAnalytics(config);
    var wizardSessionId = createWizardSessionId(config);
    var wizardTrackingBase = {
      wizard_session_id: wizardSessionId,
      wizard_version: 'livefix_20260626',
      product_id: String(config.product.id || ''),
      product_handle: String(config.product.handle || ''),
      product_variant_id: String(config.product.variantId || '')
    };
    var wizardStepKeys = ['frame', 'background', 'accessories', 'upload', 'extras'];
    var lastTrackedStepIndex = null;
    var state = {
      activeStep: 0,
      frame: config.frameOptions && config.frameOptions[0] ? config.frameOptions[0].name : '',
      background: config.backgroundOptions && config.backgroundOptions[0] ? config.backgroundOptions[0].name : '',
      selectedAccessories: [],
      digitalDownload: false,
      uploads: [],
      uploadDeferred: false
    };

    function getStepKey(stepIndex) {
      return wizardStepKeys[stepIndex] || 'unknown';
    }

    function getStepLabel(stepIndex) {
      return readTranslation(translations, 'steps.' + getStepKey(stepIndex), getStepKey(stepIndex));
    }

    function getCurrencyCode() {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        return String(window.Shopify.currency.active);
      }
      return 'USD';
    }

    function getTextLengthBucket(value) {
      var length = String(value || '').trim().length;
      if (!length) return 'empty';
      if (length <= 10) return '1_10';
      if (length <= 30) return '11_30';
      if (length <= 80) return '31_80';
      return '81_plus';
    }

    function trackEvent(eventName, params) {
      var payload = {};
      Object.keys(wizardTrackingBase).forEach(function (key) {
        payload[key] = wizardTrackingBase[key];
      });
      Object.keys(params || {}).forEach(function (key) {
        payload[key] = params[key];
      });
      analytics.track(eventName, payload);
    }

    function getSelectedAccessoriesValue() {
      return state.selectedAccessories.length ? state.selectedAccessories.join('|') : 'none';
    }

    function getUploadSelectionValue() {
      if (state.uploadDeferred) return 'send_later';
      if (getUploadedEntries().length) return 'uploaded';
      return 'pending';
    }

    function getCurrentStepOptionValue(stepIndex) {
      var stepKey = getStepKey(stepIndex);
      if (stepKey === 'frame') return state.frame || 'none';
      if (stepKey === 'background') return state.background || 'none';
      if (stepKey === 'accessories') return getSelectedAccessoriesValue();
      if (stepKey === 'upload') return getUploadSelectionValue();
      if (stepKey === 'extras') return state.digitalDownload ? 'digital_enabled' : 'none';
      return '';
    }

    function getWizardSelectionSummary() {
      return {
        frame_value: state.frame || 'none',
        background_value: state.background || 'none',
        selected_accessories: getSelectedAccessoriesValue(),
        digital_download: state.digitalDownload ? 'enabled' : 'disabled',
        upload_selection: getUploadSelectionValue()
      };
    }

    function trackStepViewed(stepIndex) {
      if (lastTrackedStepIndex === stepIndex) return;
      lastTrackedStepIndex = stepIndex;
      trackEvent('wizard_step_viewed', {
        step_index: stepIndex + 1,
        step_key: getStepKey(stepIndex),
        step_label: getStepLabel(stepIndex),
        option_value: getCurrentStepOptionValue(stepIndex)
      });
    }

    function trackStepCompleted(stepIndex, extraParams) {
      var payload = {
        step_index: stepIndex + 1,
        step_key: getStepKey(stepIndex),
        step_label: getStepLabel(stepIndex),
        option_value: getCurrentStepOptionValue(stepIndex)
      };
      Object.keys(extraParams || {}).forEach(function (key) {
        payload[key] = extraParams[key];
      });
      trackEvent('wizard_step_completed', payload);
    }

    function trackOptionSelected(stepIndex, optionType, optionValue, extraParams) {
      var payload = {
        step_index: stepIndex + 1,
        step_key: getStepKey(stepIndex),
        option_type: optionType,
        option_value: optionValue
      };
      Object.keys(extraParams || {}).forEach(function (key) {
        payload[key] = extraParams[key];
      });
      trackEvent('wizard_option_selected', payload);
    }

    function trackTextEntered(fieldName, value) {
      trackEvent('wizard_text_entered', {
        step_index: 5,
        step_key: 'extras',
        field_name: fieldName,
        has_value: Boolean(String(value || '').trim()),
        value_length_bucket: getTextLengthBucket(value)
      });
    }

    function buildAnalyticsItems() {
      var items = [
        {
          item_id: String(config.product.variantId || config.product.id || ''),
          item_name: String(config.product.title || ''),
          item_variant: String(config.product.variantId || ''),
          price: Number((Number(config.product.price || 0) / 100).toFixed(2)),
          quantity: 1,
          item_category: 'wizard'
        }
      ];

      state.selectedAccessories.forEach(function (key) {
        var addOn = config.addOns[key];
        if (!addOn || !addOn.variantId) return;
        items.push({
          item_id: String(addOn.variantId),
          item_name: String(addOn.productTitle || key),
          item_variant: String(addOn.variantId),
          price: Number((Number(addOn.price || 0) / 100).toFixed(2)),
          quantity: 1,
          item_category: 'wizard_addon'
        });
      });

      if (state.digitalDownload && config.addOns.digital && config.addOns.digital.variantId) {
        items.push({
          item_id: String(config.addOns.digital.variantId),
          item_name: String(config.addOns.digital.productTitle || 'Digital Download'),
          item_variant: String(config.addOns.digital.variantId),
          price: Number((Number(config.addOns.digital.price || 0) / 100).toFixed(2)),
          quantity: 1,
          item_category: 'wizard_addon'
        });
      }

      return items;
    }

    function getAddOnPrice(key) {
      return Number(config.addOns && config.addOns[key] ? config.addOns[key].price || 0 : 0);
    }

    function buildAccessoryOptions() {
      return [
        { key: 'name', name: readTranslation(translations, 'accessories.petName', 'Pet Name'), priceLabel: formatAddonLabel(getAddOnPrice('name')), inputPlaceholder: readTranslation(translations, 'accessories.petNamePlaceholder', 'Pet name'), disabled: !config.addOns.name.variantId },
        { key: 'bow', name: readTranslation(translations, 'accessories.bow', 'Bowtie'), priceLabel: formatAddonLabel(getAddOnPrice('bow')), disabled: !config.addOns.bow.variantId },
        { key: 'flower', name: readTranslation(translations, 'accessories.flower', 'Flower'), priceLabel: formatAddonLabel(getAddOnPrice('flower')), disabled: !config.addOns.flower.variantId },
        { key: 'halo', name: readTranslation(translations, 'accessories.halo', 'Angel Halo'), priceLabel: formatAddonLabel(getAddOnPrice('halo')), disabled: !config.addOns.halo.variantId }
      ].map(function (item) {
        item.selected = state.selectedAccessories.indexOf(item.key) >= 0;
        item.disabledLabel = readTranslation(translations, 'accessories.unavailable', 'Unavailable on this test store');
        return item;
      });
    }

    function getDisplayedTotal() {
      var total = Number(config.product.price || 0);
      state.selectedAccessories.forEach(function (key) {
        total += getAddOnPrice(key);
      });
      if (state.digitalDownload) total += getAddOnPrice('digital');
      return total;
    }

    function updatePriceUI() {
      var total = getDisplayedTotal();
      mount.querySelectorAll('.pw-live-price').forEach(function (node) {
        node.textContent = formatMoney(total);
      });

      mount.querySelectorAll('.pw-live-price-compare').forEach(function (node) {
        var compare = Number(config.product.compareAtPrice || 0);
        if (compare > total) {
          node.textContent = formatMoney(compare);
          node.style.display = 'block';
        } else {
          node.textContent = '';
          node.style.display = 'none';
        }
      });
    }

    function updateStickyActionButton() {
      var button = mount.querySelector('[data-mobile-sticky-action]');
      if (!button) return;
      button.textContent = isWizardComplete()
        ? readTranslation(translations, 'buttons.addToCart', 'Add to Cart')
        : readTranslation(translations, 'buttons.continue', 'Continue');
    }

    function bindFooterVisibilityObserver() {
      if (section.__footerVisibilityObserver) {
        section.__footerVisibilityObserver.disconnect();
      }
      if (typeof IntersectionObserver !== 'function') {
        updateMobileStickyVisibility();
        return;
      }
      var bar = mount.querySelector('[data-mobile-sticky-bar]');
      var footerBar = mount.querySelector('.pw-panel.is-active .pw-footer-bar');
      if (!bar || !footerBar) return;
      section.__footerVisibilityObserver = new IntersectionObserver(function (entries) {
        var entry = entries && entries[0];
        if (!entry) return;
        bar.hidden = entry.isIntersecting && entry.intersectionRatio > 0;
      }, {
        threshold: [0, 0.01, 0.1]
      });
      section.__footerVisibilityObserver.observe(footerBar);
      updateMobileStickyVisibility();
    }

    function updateBackControls(stepIndex) {
      var hidden = stepIndex <= 0;
      mount.querySelectorAll('[data-step-back], [data-mobile-step-back]').forEach(function (button) {
        button.hidden = hidden;
      });
    }

    function triggerUploadPicker(input) {
      if (!input) return;
      if (typeof input.showPicker === 'function') {
        try {
          input.showPicker();
          return;
        } catch (error) {
        }
      }
      input.click();
    }

    function bindUploadTriggers(uploadInput) {
      mount.querySelectorAll('[data-upload-trigger], [data-upload-placeholder-trigger]').forEach(function (button) {
        if (button.dataset.uploadTriggerBound === 'true') return;
        button.dataset.uploadTriggerBound = 'true';
        button.addEventListener('click', function (event) {
          event.preventDefault();
          if (!uploadInput || button.disabled) return;
          trackEvent('wizard_upload_button_clicked', {
            step_index: 4,
            step_key: 'upload',
            trigger_type: button.hasAttribute('data-upload-placeholder-trigger') ? 'placeholder' : 'primary',
            uploaded_photo_count: getUploadedEntries().length,
            pending_photo_count: getPendingUploadEntries().length,
            option_value: getUploadSelectionValue()
          });
          triggerUploadPicker(uploadInput);
        });
      });
    }

      function getUploadedEntries() {
        return state.uploads.filter(function (entry) {
          return Boolean(getUploadRemoteUrl(entry));
        });
      }

      function getPendingUploadEntries() {
        return state.uploads.filter(function (entry) {
          return getUploadStatus(entry) === 'pending';
        });
      }

      function isUploadSatisfied() {
        return Boolean(state.uploadDeferred || getUploadedEntries().length || getPendingUploadEntries().length);
      }

    function isWizardComplete() {
      return Boolean(state.frame && state.background && isUploadSatisfied());
    }

    function render() {
      mount.innerHTML = window.PawmoryProductWizard.renderWizardMarkup({
        priceHtml: buildPriceMarkup(),
        state: {
          activeStep: state.activeStep,
          frame: state.frame,
          background: state.background,
          extras: state.selectedAccessories,
          petName: state.petName || '',
          notes: state.notes || '',
          digitalDownload: state.digitalDownload
        },
        options: {
          steps: [
            readTranslation(translations, 'steps.frame', 'Frame'),
            readTranslation(translations, 'steps.background', 'Background'),
            readTranslation(translations, 'steps.accessories', 'Accessories'),
            readTranslation(translations, 'steps.upload', 'Upload'),
            readTranslation(translations, 'steps.extras', 'Extras')
          ],
          translations: config.translations,
          frames: config.frameOptions.map(function (frame) {
            return {
              name: frame.name,
              image: frame.image,
              tag: frame.tag || '',
              upcharge: ''
            };
          }),
          backgrounds: config.backgroundOptions,
          accessories: buildAccessoryOptions(),
          allStepsComplete: isWizardComplete(),
          digitalPriceLabel: formatAddonLabel(getAddOnPrice('digital')),
          digitalDisabled: !config.addOns.digital.variantId,
          digitalDisabledLabel: readTranslation(translations, 'digital.unavailable', 'Unavailable on this test store'),
          photoGuideImage: config.photoGuide.image,
          photoGuideTitle: config.photoGuide.title,
          photoGuideBody: config.photoGuide.body,
          photoGuideTips: config.photoGuide.tips,
          skipUploadImage: config.skipUpload.image,
          skipUploadTitle: config.skipUpload.title,
          skipUploadLead: config.skipUpload.lead,
          skipUploadBody: config.skipUpload.body,
          frameDetailsText: '',
          freeShippingText: readTranslation(translations, 'misc.freeShipping', 'Congrats! You\'ve earned FREE SHIPPING'),
          uploadHelperText: readTranslation(translations, 'upload.helperText', 'Upload pet photos to begin.')
        }
      });

      updatePriceUI();
      bindWizardEvents();
      renderUploadList();
      updateStickyActionButton();
      updateBackControls(state.activeStep || 0);
      bindFooterVisibilityObserver();
      updateMobileStickyVisibility();
    }

    function setWizardStatus(message) {
      var status = mount.querySelector('#pw-status-banner');
      if (!status) return;
      status.textContent = message || '';
      status.hidden = !message;
    }

    function scrollToWizardTarget() {
      var target = section.querySelector('.pwt-info') || mount.querySelector('[data-wizard-anchor]');
      if (!target) return;
      var header = document.querySelector('sticky-header, .shopify-section-group-header-group, header');
      var offset = header ? Math.ceil(header.getBoundingClientRect().height) + 8 : 96;
      var nextTop = Math.max(window.scrollY + target.getBoundingClientRect().top - offset, 0);
      window.scrollTo({ top: nextTop, behavior: 'smooth' });
    }

    function setWizardStep(stepIndex, options) {
      var panels = mount.querySelectorAll('.pw-panel');
      var steps = mount.querySelectorAll('.pw-step');
      if (stepIndex < 0 || stepIndex >= panels.length) return;
      var currentScrollY = window.scrollY;
      state.activeStep = stepIndex;
      panels.forEach(function (panel, index) {
        panel.classList.toggle('is-active', index === stepIndex);
      });
      steps.forEach(function (step, index) {
        step.classList.toggle('is-active', index === stepIndex);
        step.classList.toggle('is-done', index < stepIndex);
      });
      updateStickyActionButton();
      updateBackControls(stepIndex);
      bindFooterVisibilityObserver();
      updateMobileStickyVisibility();
      updateDesktopReturnCta();
      trackStepViewed(stepIndex);
      if ((!options || options.scroll !== false) && window.innerWidth < 960) {
        scrollToWizardTarget();
      } else if (window.innerWidth >= 960) {
        window.scrollTo({ top: currentScrollY, behavior: 'auto' });
      }
    }

      function renderUploadList() {
        var uploadList = mount.querySelector('#pw-upload-list');
        var uploadButton = mount.querySelector('.pw-upload-dropzone__button');
        var uploadInput = mount.querySelector('#pw-upload-input');
        if (!uploadList) return;
        if (!state.uploads.length) {
        uploadList.innerHTML = '<div class="pw-upload-list__empty"><button class="pw-upload-list__placeholder" type="button" data-upload-placeholder-trigger><span class="pw-upload-list__placeholder-icon" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><path d="M12 16V7.5M8.5 11 12 7.5 15.5 11M6 16.5v1a1.5 1.5 0 0 0 1.5 1.5h9a1.5 1.5 0 0 0 1.5-1.5v-1" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span><span class="pw-upload-list__placeholder-text">' + escapeHtml(readTranslation(translations, 'upload.placeholderText', 'Upload pet photos')) + '</span></button></div>';
        } else {
          uploadList.innerHTML = state.uploads.map(function (entry, index) {
          var preview = getUploadPreviewUrl(entry);
          var status = getUploadStatus(entry);
          var media = preview
            ? '<img src="' + escapeHtml(preview) + '" alt="Uploaded photo ' + (index + 1) + '">'
            : '<div class="pw-upload-list__placeholder" aria-hidden="true"></div>';
          var label = status === 'failed'
            ? readTranslation(translations, 'upload.failed', 'Failed')
            : status === 'pending'
              ? readTranslation(translations, 'upload.uploading', 'Uploading...')
              : readTranslation(translations, 'upload.uploaded', 'Uploaded');
          return '<div class="pw-upload-list__item"><button class="pw-upload-list__remove" type="button" data-upload-remove="' + index + '">Remove</button>' + media + '<span>' + escapeHtml(label) + '</span></div>';
          }).join('');
        }
      if (uploadButton) {
        uploadButton.disabled = state.uploads.length >= 3;
        uploadButton.textContent = state.uploads.length >= 3
          ? readTranslation(translations, 'buttons.maximumPhotosAdded', 'Maximum photos added')
          : readTranslation(translations, 'buttons.uploadPhotos', 'Upload Photos');
      }
      if (uploadInput) uploadInput.disabled = state.uploads.length >= 3;
      bindUploadTriggers(mount.querySelector('#pw-upload-input'));
      uploadList.querySelectorAll('[data-upload-remove]').forEach(function (button) {
        button.addEventListener('click', function () {
          var index = Number(button.getAttribute('data-upload-remove'));
          var removedEntry = state.uploads[index];
          state.uploads.splice(index, 1);
          state.uploadDeferred = false;
          trackEvent('wizard_upload_removed', {
            step_index: 4,
            step_key: 'upload',
            file_index: index + 1,
            removed_status: getUploadStatus(removedEntry),
            uploaded_photo_count: getUploadedEntries().length,
            pending_photo_count: getPendingUploadEntries().length,
            option_value: getUploadSelectionValue()
          });
          renderUploadList();
          updateStickyActionButton();
        });
      });
    }

      function uploadFiles(files, index) {
        if (!files || !files[index]) return;
        var file = files[index];
        var entry = { url: '', preview: '', status: 'pending' };
        state.uploadDeferred = false;
        state.uploads.push(entry);
        renderUploadList();

        var reader = new FileReader();
        reader.onload = function (event) {
          entry.preview = event.target.result || '';
          renderUploadList();
        };
        reader.readAsDataURL(file);

      var formData = new FormData();
      formData.append('file', file);
      formData.append('upload_preset', config.cloudinary.uploadPreset);
      fetch('https://api.cloudinary.com/v1_1/' + config.cloudinary.cloudName + '/image/upload', {
        method: 'POST',
        body: formData
      })
          .then(function (response) { return response.json(); })
          .then(function (data) {
            if (data.secure_url) {
              entry.url = data.secure_url;
              entry.preview = entry.preview || data.secure_url;
              entry.status = 'uploaded';
              state.uploadDeferred = false;
              trackEvent('wizard_upload_completed', {
                step_index: 4,
                step_key: 'upload',
                file_index: index + 1,
                uploaded_photo_count: getUploadedEntries().length + 1
              });
            } else {
              entry.status = 'failed';
              trackEvent('wizard_upload_failed', {
                step_index: 4,
                step_key: 'upload',
                file_index: index + 1
              });
            }
            renderUploadList();
            updateStickyActionButton();
            if (files[index + 1]) uploadFiles(files, index + 1);
          })
          .catch(function () {
            entry.status = 'failed';
            trackEvent('wizard_upload_failed', {
              step_index: 4,
              step_key: 'upload',
              file_index: index + 1
            });
            renderUploadList();
            if (files[index + 1]) uploadFiles(files, index + 1);
          });
      }

    function createParentProperties(bundleKey) {
      var petNameInput = mount.querySelector('.pw-accessory__input');
      var notesInput = mount.querySelector('#pw-notes');
      var properties = {
        [readTranslation(translations, 'cart.frame', 'Frame')]: state.frame,
        [readTranslation(translations, 'cart.background', 'Background')]: state.background,
        _bundle_key: bundleKey,
        _bundle_role: 'parent',
        _wizard_session_id: wizardSessionId,
        _wizard_product_handle: String(config.product.handle || ''),
        _wizard_product_id: String(config.product.id || ''),
        _wizard_variant_id: String(config.product.variantId || '')
      };
      if (
        state.selectedAccessories.indexOf('name') >= 0 &&
        petNameInput &&
        petNameInput.value.trim()
      ) properties[readTranslation(translations, 'cart.petName', 'Pet Name')] = petNameInput.value.trim();
      if (notesInput && notesInput.value.trim()) properties[readTranslation(translations, 'cart.note', 'Note')] = notesInput.value.trim();
        if (getUploadedEntries().length) {
          properties[readTranslation(translations, 'cart.uploadedPhotos', 'Uploaded photos')] = getUploadedEntries().length + ' photo' + (getUploadedEntries().length > 1 ? 's' : '');
        }
        getUploadedEntries().forEach(function (entry, index) {
          properties['_File upload-' + (index + 1)] = getUploadRemoteUrl(entry);
        });
        return properties;
      }

    function buildCartItems(bundleKey) {
      var items = [
        {
          id: Number(config.product.variantId),
          quantity: 1,
          properties: createParentProperties(bundleKey)
        }
      ];

      state.selectedAccessories.forEach(function (key) {
        var addOn = config.addOns[key];
        if (!addOn || !addOn.variantId) return;
        items.push({
          id: Number(addOn.variantId),
          quantity: 1,
          properties: {
            _bundle_key: bundleKey,
            _bundle_role: 'child',
            _bundle_parent_id: String(config.product.variantId || ''),
            _wizard_session_id: wizardSessionId
          }
        });
      });

      if (state.digitalDownload && config.addOns.digital && config.addOns.digital.variantId) {
        items.push({
          id: Number(config.addOns.digital.variantId),
          quantity: 1,
          properties: {
            _bundle_key: bundleKey,
            _bundle_role: 'child',
            _bundle_parent_id: String(config.product.variantId || ''),
            _wizard_session_id: wizardSessionId
          }
        });
      }

      return items;
    }

    function getCartSectionIds() {
      return Array.prototype.slice.call(document.querySelectorAll('cart-items-component'))
        .map(function (node) { return node && node.dataset ? node.dataset.sectionId : ''; })
        .filter(Boolean);
    }

    function dispatchCartUpdate(response, itemCount) {
      var event = new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: response || {},
          sourceId: 'pawmory-wizard-test',
          data: {
            source: 'pawmory-wizard-test',
            itemCount: itemCount || 1,
            productId: String(config.product.id || ''),
            variantId: String(config.product.variantId || ''),
            sections: response && response.sections ? response.sections : {}
          }
        }
      });

      mount.dispatchEvent(event);
      document.dispatchEvent(event);
    }

    function openCartDrawer() {
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return true;
      }
      if (drawer && typeof drawer.showDialog === 'function') {
        drawer.showDialog();
        return true;
      }
      var headerCartButton = document.querySelector('[aria-controls*="cart"], .header-actions__cart-icon, a[href="/cart"]');
      if (headerCartButton && typeof headerCartButton.click === 'function') {
        headerCartButton.click();
        return true;
      }
      return false;
    }

    function submitWizard() {
      var button = mount.querySelector('.pw-panel.is-active .pw-footer-bar__next');
      if (!isWizardComplete()) {
        setWizardStatus(readTranslation(translations, 'status.incomplete', 'Please finish the required steps before adding to cart.'));
        return;
      }

      if (getPendingUploadEntries().length) {
        if (button) {
          button.disabled = true;
          button.textContent = readTranslation(translations, 'upload.uploading', 'Uploading...');
        }
        setWizardStatus(readTranslation(translations, 'upload.uploading', 'Uploading...'));
        setTimeout(submitWizard, 400);
        return;
      }

      var bundleKey = 'wizard_' + Date.now();
      var items = buildCartItems(bundleKey);

      if (button) {
        button.disabled = true;
        button.textContent = readTranslation(translations, 'status.adding', 'Adding...');
      }
      setWizardStatus('');
      trackEvent('wizard_add_to_cart_clicked', Object.assign({
        selected_accessory_count: state.selectedAccessories.length,
        uploaded_photo_count: getUploadedEntries().length,
        upload_mode: state.uploadDeferred ? 'deferred' : 'uploaded',
        has_pet_name: Boolean(state.petName && state.petName.trim()),
        has_notes: Boolean(state.notes && state.notes.trim()),
        value: Number((getDisplayedTotal() / 100).toFixed(2)),
        currency: getCurrencyCode()
      }, getWizardSelectionSummary()));

      var sectionIds = getCartSectionIds();
      var payload = {
        items: items
      };

      if (sectionIds.length) {
        payload.sections = sectionIds.join(',');
        payload.sections_url = window.location.pathname;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to add the wizard bundle right now.');
          return response.json();
        })
        .then(function (response) {
          trackEvent('wizard_add_to_cart_succeeded', Object.assign({
            item_count: items.length,
            uploaded_photo_count: getUploadedEntries().length,
            upload_mode: state.uploadDeferred ? 'deferred' : 'uploaded'
          }, getWizardSelectionSummary()));
          trackEvent('add_to_cart', Object.assign({
            currency: getCurrencyCode(),
            value: Number((getDisplayedTotal() / 100).toFixed(2)),
            items: buildAnalyticsItems()
          }, getWizardSelectionSummary()));
          dispatchCartUpdate(response, items.length);
          state.activeStep = 0;
          state.frame = config.frameOptions && config.frameOptions[0] ? config.frameOptions[0].name : '';
          state.background = config.backgroundOptions && config.backgroundOptions[0] ? config.backgroundOptions[0].name : '';
          state.selectedAccessories = [];
          state.digitalDownload = false;
          state.uploads = [];
          state.uploadDeferred = false;
          state.petName = '';
          state.notes = '';
          render();
          if (!openCartDrawer()) {
            window.location.href = '/cart';
          }
        })
        .catch(function (error) {
          trackEvent('wizard_add_to_cart_failed', {
            failure_stage: 'cart_add',
            uploaded_photo_count: getUploadedEntries().length,
            upload_mode: state.uploadDeferred ? 'deferred' : 'uploaded'
          });
          setWizardStatus(error && error.message ? error.message : readTranslation(translations, 'status.addError', 'Unable to add the wizard bundle right now.'));
          if (button) {
            button.disabled = false;
            button.textContent = readTranslation(translations, 'status.tryAgain', 'Try again');
          }
        });
    }

    function updateMobileStickyVisibility() {
      var bar = mount.querySelector('[data-mobile-sticky-bar]');
      var footerBar = mount.querySelector('.pw-panel.is-active .pw-footer-bar');
      if (!bar || !footerBar) return;
      var rect = footerBar.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      var footerVisible = rect.top < viewportHeight && rect.bottom > 0;
      bar.hidden = footerVisible;
    }

    function updateDesktopReturnCta() {
      var desktopReturn = mount.querySelector('[data-desktop-return-cta]');
      if (!desktopReturn) return;
      if (window.innerWidth < 960) {
        desktopReturn.hidden = true;
        return;
      }
      var cta = mount.querySelector('.pw-panel.is-active .pw-footer-bar__next');
      if (!cta) {
        desktopReturn.hidden = true;
        return;
      }
      var rect = cta.getBoundingClientRect();
      desktopReturn.hidden = rect.bottom > 120 && rect.top < window.innerHeight - 8;
    }

    function bindWizardEvents() {
      mount.querySelectorAll('.pw-step').forEach(function (button, index) {
        button.addEventListener('click', function () {
          setWizardStep(index, { scroll: window.innerWidth < 960 });
        });
      });

      mount.querySelectorAll('[data-frame]').forEach(function (button) {
        button.addEventListener('click', function () {
          state.frame = button.getAttribute('data-frame') || state.frame;
          trackOptionSelected(0, 'frame', state.frame);
          render();
          setWizardStep(0, { scroll: false });
        });
      });

      mount.querySelectorAll('[data-background]').forEach(function (button) {
        button.addEventListener('click', function () {
          state.background = button.getAttribute('data-background') || state.background;
          trackOptionSelected(1, 'background', state.background);
          render();
          setWizardStep(1, { scroll: false });
        });
      });

      mount.querySelectorAll('[data-accessory]').forEach(function (input) {
        input.addEventListener('change', function () {
          var key = input.getAttribute('data-accessory');
          if (!key) return;
          setWizardStatus('');
          if (input.checked && state.selectedAccessories.indexOf(key) < 0) {
            state.selectedAccessories.push(key);
          }
          if (!input.checked) {
            state.selectedAccessories = state.selectedAccessories.filter(function (item) { return item !== key; });
            if (key === 'name') {
              state.petName = '';
            }
          }
          input.closest('.pw-accessory').classList.toggle('is-selected', input.checked);
          trackOptionSelected(2, 'accessory', key, {
            selection_state: input.checked ? 'selected' : 'removed'
          });
          updatePriceUI();
          render();
          setWizardStep(2, { scroll: false });
        });
      });

      var digitalInput = mount.querySelector('#pw-digital-download');
      if (digitalInput) {
        digitalInput.addEventListener('change', function (event) {
          state.digitalDownload = event.target.checked;
          var digitalToggle = event.target.closest('.pw-digital-toggle') || event.target.closest('.pw-accessory');
          if (digitalToggle) {
            digitalToggle.classList.toggle('is-selected', event.target.checked);
          }
          trackOptionSelected(4, 'digital_download', event.target.checked ? 'enabled' : 'disabled');
          updatePriceUI();
        });
      }

      var petNameInput = mount.querySelector('.pw-accessory__input');
      if (petNameInput) {
        petNameInput.addEventListener('input', function (event) {
          state.petName = event.target.value;
        });
        petNameInput.addEventListener('blur', function (event) {
          trackTextEntered('pet_name', event.target.value);
        });
      }

      var notesInput = mount.querySelector('#pw-notes');
      if (notesInput) {
        notesInput.addEventListener('input', function (event) {
          state.notes = event.target.value;
        });
        notesInput.addEventListener('blur', function (event) {
          trackTextEntered('notes', event.target.value);
        });
      }

      mount.querySelectorAll('.pw-panel').forEach(function (panel, index) {
        var nextButton = panel.querySelector('.pw-footer-bar__next');
        if (!nextButton) return;
        nextButton.addEventListener('click', function () {
          if (index === 3 && !isUploadSatisfied()) {
            mount.querySelector('.pw-skip-upload-modal').hidden = false;
            return;
          }
          if (index < 4) {
            trackStepCompleted(index, {
              uploaded_photo_count: getUploadedEntries().length,
              selected_accessory_count: state.selectedAccessories.length,
              upload_mode: state.uploadDeferred ? 'deferred' : 'uploaded'
            });
            setWizardStep(index + 1, { scroll: window.innerWidth < 960 });
          } else {
            submitWizard();
          }
        });
      });

      mount.querySelectorAll('[data-step-back]').forEach(function (button) {
        button.addEventListener('click', function () {
          setWizardStep(Math.max(state.activeStep - 1, 0), { scroll: window.innerWidth < 960 });
        });
      });

      var uploadInput = mount.querySelector('#pw-upload-input');
      if (uploadInput) {
        uploadInput.addEventListener('change', function (event) {
          var files = Array.prototype.slice.call(event.target.files || []).slice(0, Math.max(0, 3 - state.uploads.length));
          if (files.length) {
            trackEvent('wizard_upload_started', {
              step_index: 4,
              step_key: 'upload',
              file_count: files.length,
              existing_file_count: state.uploads.length
            });
            uploadFiles(files, 0);
          }
          event.target.value = '';
        });
      }

      bindUploadTriggers(uploadInput);

      var guideButton = mount.querySelector('.pw-upload-dropzone__guide-link');
      if (guideButton) {
        guideButton.addEventListener('click', function () {
          trackEvent('wizard_photo_guides_viewed', {
            step_index: 4,
            step_key: 'upload',
            uploaded_photo_count: getUploadedEntries().length,
            pending_photo_count: getPendingUploadEntries().length,
            option_value: getUploadSelectionValue()
          });
          mount.querySelector('.pw-upload-modal').hidden = false;
        });
      }

      var guideClose = mount.querySelector('.pw-upload-modal__close');
      if (guideClose) {
        guideClose.addEventListener('click', function () {
          mount.querySelector('.pw-upload-modal').hidden = true;
        });
      }

      var skipClose = mount.querySelector('.pw-skip-upload-modal__close');
      if (skipClose) {
        skipClose.addEventListener('click', function () {
          mount.querySelector('.pw-skip-upload-modal').hidden = true;
        });
      }

        mount.querySelectorAll('[data-skip-upload-action]').forEach(function (button) {
          button.addEventListener('click', function () {
            var action = button.getAttribute('data-skip-upload-action');
            mount.querySelector('.pw-skip-upload-modal').hidden = true;
            if (action === 'later') {
              state.uploadDeferred = true;
              trackOptionSelected(3, 'upload_preference', 'send_later');
              trackStepCompleted(3, {
                uploaded_photo_count: 0,
                upload_mode: 'deferred'
              });
              setWizardStep(4, { scroll: window.innerWidth < 960 });
            } else if ((action === 'now' || action === 'upload') && uploadInput) {
              trackOptionSelected(3, 'upload_preference', 'upload_now');
              trackEvent('wizard_upload_button_clicked', {
                step_index: 4,
                step_key: 'upload',
                trigger_type: 'skip_modal',
                uploaded_photo_count: getUploadedEntries().length,
                pending_photo_count: getPendingUploadEntries().length,
                option_value: getUploadSelectionValue()
              });
              triggerUploadPicker(uploadInput);
            }
          });
        });

      var mobileButton = mount.querySelector('[data-mobile-sticky-action]');
      if (mobileButton) {
        mobileButton.addEventListener('click', function () {
          if (isWizardComplete()) {
            submitWizard();
            return;
          }
          scrollToWizardTarget();
        });
      }

      mount.querySelectorAll('[data-mobile-step-back]').forEach(function (button) {
        button.addEventListener('click', function () {
          setWizardStep(Math.max(state.activeStep - 1, 0), { scroll: true });
        });
      });

      var desktopReturn = mount.querySelector('[data-desktop-return-cta]');
      if (desktopReturn) {
        desktopReturn.addEventListener('click', function () {
          scrollToWizardTarget();
        });
      }
    }

    render();
    trackEvent('wizard_started', {
      product_id: String(config.product.id || ''),
      product_handle: String(config.product.handle || ''),
      product_variant_id: String(config.product.variantId || ''),
      measurement_id: analytics.measurementId || ''
    });
    trackStepViewed(state.activeStep);

    updateDesktopReturnCta();
    if (!section.__wizardViewportBound) {
      section.__wizardViewportBound = true;
      window.addEventListener('scroll', updateMobileStickyVisibility, { passive: true });
      window.addEventListener('resize', updateMobileStickyVisibility);
      window.addEventListener('scroll', updateDesktopReturnCta, { passive: true });
      window.addEventListener('resize', updateDesktopReturnCta);
    }
  }

  function init() {
    runtimeState.initCallCount += 1;
    document.querySelectorAll('[data-wizard-test-section]').forEach(function (section) {
      initGallery(section);
      initWizard(section);
    });
  }

  function initWhenReady(attempt) {
    init();
    if (window.__pawmoryWizardGa4) return;
    if ((attempt || 0) >= 10) return;
    window.setTimeout(function () {
      initWhenReady((attempt || 0) + 1);
    }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initWhenReady(0);
    });
  } else {
    initWhenReady(0);
  }
})();
